import { withNamespaces } from 'react-i18next';
import { Card, CardBody } from 'reactstrap';

import { BidStatuses } from '../../../../constants';
import NodeHandles from './NodeHandles';

const BidSourceNode = ({
    data,
    t,
}) => {
    const { freight } = data;
    const status = BidStatuses[data.bidStatus];

    return (
        <>
            <NodeHandles />

            <Card className="mb-0 live-verification-box" style={{ width: 210 }}>
                <CardBody className="p-3">
                    <div className="avatar-xs mb-2">
                        <span className="avatar-title rounded-circle bg-soft-primary text-primary font-size-16">
                            <i className="ri-truck-line" />
                        </span>
                    </div>

                    <h6 className="mb-1">{data.label}</h6>

                    <p className="text-muted font-size-11 mb-2">
                        {`${freight.origin} → ${freight.destination}`}
                    </p>

                    <ul className="list-unstyled font-size-11 text-muted mb-2">
                        <li>
                            <i className="ri-archive-line align-middle me-1" />
                            {freight.cargoType}
                        </li>
                        <li>
                            <i className="ri-scales-2-line align-middle me-1" />
                            {`${new Intl.NumberFormat('de-DE').format(freight.weight)} kg`}
                        </li>
                        <li>
                            <i className="ri-calendar-line align-middle me-1" />
                            {freight.pickupDate}
                        </li>
                    </ul>

                    <span className={`badge font-size-11 ${status.className}`}>
                        {t(data.bidStatus)}
                    </span>
                </CardBody>
            </Card>
        </>
    );
};

export default withNamespaces()(BidSourceNode);
